<template>
    <b-modal
        v-model="mostrarModalLocal"
        @show="preencherModal()"
        @hidden="fecharModal()"
        size="xl"
        no-close-on-backdrop
    >
        <div slot="modal-title">{{ titulo }}</div>
        <app-erros-box
            :erros="erros"
            v-if="erros.length > 0 && operacao != 'D'"
        ></app-erros-box>
        <h5 class="heading-1 mb-4" v-if="operacao != 'D'">
            <span>ITENS DA REQUISIÇÃO - DISPONÍVEIS</span>
        </h5>
        <b-row v-if="operacao != 'D'">
            <b-col sm="12">
                <app-tabela
                    :itens="itensNaoSelecionados"
                    :campos="campos"
                    :itensPorPagina="itensPorPagina"
                    :bordered="false"
                    :small="true"
                >
                    <template slot="botoes">
                        <b-button-group class="float-right">
                            <btn-selecionar-todos-itens-requisicao-rateio
                                :itensRequisicao="itensNaoSelecionados"
                                @selecionarItem="selecionarItem($event)"
                            >
                            </btn-selecionar-todos-itens-requisicao-rateio>
                        </b-button-group>
                    </template>
                    <template slot="acoes" slot-scope="data">
                        <btn-selecionar-item-requisicao-rateio
                            :itemRequisicao="data"
                            @selecionarItem="selecionarItem($event)"
                        ></btn-selecionar-item-requisicao-rateio>
                    </template>
                    <template slot="valorUnitario" slot-scope="data">{{
                        data.valorUnitario | currency
                    }}</template>
                    <template slot="quantidade" slot-scope="data">{{
                        data.quantidade | currency2
                    }}</template>
                    <template slot="subTotal" slot-scope="data">{{
                        data.subTotal | currency
                    }}</template>
                    <template slot="desconto" slot-scope="data">{{
                        data.desconto | currency
                    }}</template>
                    <template slot="valorTotal" slot-scope="data">{{
                        data.valorTotal | currency
                    }}</template>
                    <template slot="totalRateado" slot-scope="data">{{
                        data.totalRateado | currency
                    }}</template>
                    <template slot="saldoASerRateado" slot-scope="data">{{
                        data.saldoASerRateado | currency
                    }}</template>
                </app-tabela>
            </b-col>
        </b-row>
        <h5 class="heading-1 mb-4">
            <span>ITENS DA REQUISIÇÃO - SELECIONADOS</span>
        </h5>
        <b-row>
            <b-col sm="12">
                <app-tabela
                    :itens="itensSelecionados"
                    :campos="campos2"
                    :itensPorPagina="itensPorPagina"
                    :bordered="false"
                    :small="true"
                >
                    <template slot="acoes" slot-scope="data">
                        <btn-remover-item-requisicao-rateio
                            :itemRequisicao="data"
                            @removerItem="removerItem($event)"
                            v-if="operacao != 'D'"
                        ></btn-remover-item-requisicao-rateio>
                    </template>
                    <template slot="valorUnitario" slot-scope="data">{{
                        data.valorUnitario | currency
                    }}</template>
                    <template slot="quantidade" slot-scope="data">{{
                        data.quantidade | currency2
                    }}</template>
                    <template slot="subTotal" slot-scope="data">{{
                        data.subTotal | currency
                    }}</template>
                    <template slot="desconto" slot-scope="data">{{
                        data.desconto | currency
                    }}</template>
                    <template slot="valorTotal" slot-scope="data">{{
                        data.valorTotal | currency
                    }}</template>
                    <template slot="totalRateado" slot-scope="data">{{
                        data.totalRateado | currency
                    }}</template>
                    <template slot="saldoASerRateado" slot-scope="data">{{
                        data.saldoASerRateado | currency
                    }}</template>
                    <template slot="valorRateado" slot-scope="data">{{
                        data.valorRateado | currency
                    }}</template>
                </app-tabela>
            </b-col>
        </b-row>
        <h5 class="heading-1 mb-4">
            <span>DADOS GERAIS</span>
        </h5>
        <b-row>
            <b-col sm="12" md="9">
                <b-form-group>
                    <label class="required">Histórico Comprometimento</label>
                    <b-form-textarea
                        v-model="historicoComprometimento"
                        :rows="4"
                        @input.native="$v.historicoComprometimento.$touch()"
                        :state="
                            $v.historicoComprometimento.$error ? false : null
                        "
                        :disabled="operacao == 'D'"
                    ></b-form-textarea>
                    <b-form-invalid-feedback
                        >O histórico do comprometimento é
                        obrigatório</b-form-invalid-feedback
                    >
                </b-form-group>
            </b-col>
            <b-col sm="12" md="3">
                <b-form-group
                    :state="$v.dataComprometimento.$error ? false : null"
                    invalid-feedback="Data do vencimento é obrigatória"
                >
                    <label class="required">Data do Vencimento</label>
                    <date-picker
                        v-model="dataComprometimento"
                        :config="$datePickerOptions"
                        v-mask="'##/##/####'"
                        @input.native="$v.dataComprometimento.$touch()"
                        :disabled="operacao == 'D'"
                    ></date-picker>
                </b-form-group>
            </b-col>
        </b-row>
        <h5 class="heading-1 mb-4">
            <span>RATEIO</span>
        </h5>
        <!-- <quadro-resumo-rateios-edicao
            :itensSelecionados="itensSelecionados"
            :rateios="rateios"
            :valorASerRateado="valorASerRateado"
            :valorRateado="valorRateado"
            :valorDisponivel="valorDisponivel"
            :percentualRateado="percentualRateado"
        ></quadro-resumo-rateios-edicao> -->
        <rateios
            :rateios="rateios"
            :valorASerRateado="valorASerRateado"
            :valorDisponivel="valorDisponivel"
            :operacao="operacao"
            :dataMovimento="dataComprometimento"
            :requisicao="requisicao"
            @inserirRateio="inserirRateio($event)"
            @excluirRateio="excluirRateio($event)"
            @atualizarRateio="atualizarRateio($event)"
        ></rateios>
        <div slot="modal-footer">
            <b-button
                variant="secondary"
                @click.stop="fecharModal()"
                class="mr-2"
                >{{ operacao == 'D' ? 'Fechar' : 'Cancelar' }}</b-button
            >
            <b-button
                variant="primary"
                :disabled="desabilitaSalvar"
                @click.stop="confirmarSalvar()"
                v-if="operacao != 'D'"
                >Salvar</b-button
            >
        </div>
    </b-modal>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import RequisicoesServicos from './RequisicoesServicos'
import BtnSelecionarItemRequisicaoRateio from './BtnSelecionarItemRequisicaoRateio'
import QuadroResumoRateiosEdicao from './QuadroResumoRateiosEdicao'
import BtnRemoverItemRequisicaoRateio from './BtnRemoverItemRequisicaoRateio'
import Rateios from './rateios/Rateios'
import BtnSelecionarTodosItensRequisicaoRateio from './BtnSelecionarTodosItensRequisicaoRateio'

export default {
    props: {
        requisicao: {
            type: Object
        },

        erros: {
            type: Array,
            default: () => []
        },

        titulo: {
            type: String,
            default: () => ''
        },

        mostrarModal: {
            type: Boolean,
            default: () => false
        },

        operacao: {
            type: String,
            default: () => 'D'
        },

        comprometimento: {
            type: Object
        }
    },

    components: {
        BtnSelecionarItemRequisicaoRateio,
        QuadroResumoRateiosEdicao,
        BtnRemoverItemRequisicaoRateio,
        Rateios,
        BtnSelecionarTodosItensRequisicaoRateio
    },

    data() {
        return {
            mostrarModalLocal: false,
            itensDisponiveis: [],
            itensSelecionados: [],
            rateios: [],
            historicoComprometimento: null,
            dataComprometimento: null,
            campos: [
                {
                    key: 'acoes',
                    label: ''
                },
                {
                    key: 'idItemContrato',
                    label: 'Código',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'descricao',
                    label: 'Item do Contrato',
                    filterable: true
                },
                {
                    key: 'seqRm',
                    label: 'Seq RM',
                    sortable: true,
                    tdClass: 'text-center'
                },
                {
                    key: 'valorUnitario',
                    label: 'Valor Unitário',
                    tdClass: 'text-nowrap text-right'
                },
                {
                    key: 'quantidade',
                    label: 'Quantidade',
                    tdClass: 'text-nowrap text-right'
                },
                {
                    key: 'subTotal',
                    label: 'SubTotal',
                    tdClass: 'text-nowrap text-right'
                },
                {
                    key: 'desconto',
                    label: 'Desconto',
                    tdClass: 'text-nowrap text-right'
                },
                {
                    key: 'valorTotal',
                    label: 'Valor Total',
                    tdClass: 'text-nowrap text-right'
                },
                {
                    key: 'totalRateado',
                    label: 'Total Rateado',
                    tdClass: 'text-nowrap text-right'
                },
                {
                    key: 'saldoASerRateado',
                    label: 'Saldo a Ser Rateado',
                    tdClass: 'text-nowrap text-right'
                }
            ],
            campos2: [
                {
                    key: 'acoes',
                    label: ''
                },
                {
                    key: 'idItemContrato',
                    label: 'Código',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'descricao',
                    label: 'Item do Contrato',
                    filterable: true
                },
                {
                    key: 'seqRm',
                    label: 'Seq RM',
                    sortable: true,
                    tdClass: 'text-center'
                },
                {
                    key: 'valorUnitario',
                    label: 'Valor Unitário',
                    tdClass: 'text-nowrap text-right'
                },
                {
                    key: 'quantidade',
                    label: 'Quantidade',
                    tdClass: 'text-nowrap text-right'
                },
                {
                    key: 'subTotal',
                    label: 'SubTotal',
                    tdClass: 'text-nowrap text-right'
                },
                {
                    key: 'desconto',
                    label: 'Desconto',
                    tdClass: 'text-nowrap text-right'
                },
                {
                    key: 'valorTotal',
                    label: 'Valor Total',
                    tdClass: 'text-nowrap text-right'
                },
                {
                    key: 'totalRateado',
                    label: 'Total Rateado',
                    tdClass: 'text-nowrap text-right'
                },
                {
                    key: 'saldoASerRateado',
                    label: 'Saldo a Ser Rateado',
                    tdClass: 'text-nowrap text-right'
                },
                {
                    key: 'valorRateado',
                    label: 'Valor Rateado',
                    tdClass: 'text-nowrap text-right'
                }
            ],
            itensPorPagina: 5
        }
    },

    methods: {
        fecharModal() {
            this.itensDisponiveis = []
            this.itensSelecionados = []
            this.rateios = []
            this.$emit('fecharModal')
        },

        preencherModal() {
            this.obterItensDisponiveis()
            if (this.operacao == 'A' || this.operacao == 'D') {
                this.obterComprometimento()
            } else {
                this.historicoComprometimento = this.requisicao.objeto
                this.dataComprometimento = this.$moment(
                    this.requisicao.dataNecessidade
                ).format('DD/MM/YYYY')
            }
        },

        obterItensDisponiveis() {
            this.$store.dispatch('addRequest')
            RequisicoesServicos.obterItensRequisicaoDisponiveis(
                this.requisicao.idRequisicao
            ).then((response) => {
                if (response) {
                    if (response.success) {
                        this.itensDisponiveis = [...response.data]
                    } else {
                        this.$toast.error(
                            'Erro ao obter itens da requisição',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        obterComprometimento() {
            this.$store.dispatch('addRequest')
            RequisicoesServicos.obterComprometimento(
                this.requisicao.idRequisicao,
                this.comprometimento.idComprometimento
            ).then((response) => {
                if (response) {
                    if (response.success) {
                        this.historicoComprometimento = response.data.historico
                        this.dataComprometimento = this.$moment(
                            response.data.dataMovimento
                        ).format('DD/MM/YYYY')
                        this.itensSelecionados = [...response.data.itens]
                        this.rateios = [...response.data.rateios]
                    } else {
                        this.$toast.error(
                            'Erro ao obter comprometimento',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        selecionarItem(itemSelecionado) {
            var itemTemp = this.itensNaoSelecionados.find((item) => {
                return item.idItemRequisicao == itemSelecionado.idItemRequisicao
            })
            itemTemp.valorRateado = itemSelecionado.valorRateado
            this.itensSelecionados.push(itemTemp)
        },

        removerItem(itemRemovido) {
            for (
                let index = 0;
                index < this.itensSelecionados.length;
                index++
            ) {
                const itemAtual = this.itensSelecionados[index]
                if (
                    itemAtual.idItemRequisicao == itemRemovido.idItemRequisicao
                ) {
                    var itemDisponivelTemp = this.itensDisponiveis.find(
                        (item) => {
                            return (
                                item.idItemRequisicao ==
                                itemAtual.idItemRequisicao
                            )
                        }
                    )

                    if (!itemDisponivelTemp) {
                        let indexTemp = this.itensDisponiveis.length
                        this.itensDisponiveis.push(itemAtual)
                        this.itensDisponiveis[indexTemp].saldoASerRateado =
                            this.itensDisponiveis[indexTemp].valorRateado
                        this.itensDisponiveis[indexTemp].totalRateado =
                            itemAtual.totalRateado - itemAtual.valorRateado
                        this.itensDisponiveis[
                            indexTemp
                        ].valoresRecalculados = true
                    }

                    this.itensSelecionados.splice(index, 1)

                    if (itemDisponivelTemp && this.operacao == 'A') {
                        for (
                            let index = 0;
                            index < this.itensDisponiveis.length;
                            index++
                        ) {
                            const itemAtual2 = this.itensDisponiveis[index]

                            if (
                                itemAtual2.idItemRequisicao ==
                                    itemAtual.idItemRequisicao &&
                                !itemAtual2.valoresRecalculados &&
                                itemAtual2.saldoASerRateado > 0
                            ) {
                                this.itensDisponiveis[index].saldoASerRateado =
                                    this.itensDisponiveis[index]
                                        .saldoASerRateado +
                                    itemAtual.valorRateado
                                this.itensDisponiveis[index].totalRateado =
                                    this.itensDisponiveis[index].totalRateado -
                                    itemAtual.valorRateado
                                this.itensDisponiveis[
                                    index
                                ].valoresRecalculados = true
                            }
                        }
                    }
                    break
                }
            }
        },

        confirmarSalvar() {
            this.$swal({
                title: `${
                    this.operacao == 'I' ? 'Inserção' : 'Atualização'
                } de rateio na requisição`,
                html: `Confirma a ${
                    this.operacao == 'I' ? 'inserção' : 'atualização'
                } do rateio na requisição?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then((result) => {
                if (result.value) {
                    this.salvar()
                }
            })
        },

        salvar() {
            let rateioDto = {
                itensRateios: this.itensSelecionados,
                rateios: this.rateios,
                historicoComprometimento: this.historicoComprometimento,
                dataComprometimento: this.$moment(
                    this.dataComprometimento,
                    'DD/MM/YYYY'
                ).format('YYYY-MM-DD')
            }

            if (this.operacao == 'A') {
                rateioDto.idComprometimento =
                    this.comprometimento.idComprometimento
            }

            this.$emit(
                this.operacao == 'I' ? 'inserirRateio' : 'atualizarRateio',
                rateioDto
            )
        },

        inserirRateio(rateio) {
            if (
                this.rateios.filter((r) => {
                    return (
                        r.codCCusto == rateio.codCCusto
                    )
                }).length > 0
            ) {
                this.erroNaInclusaoDotacao()
            } else {
                this.rateios.push(rateio)
            }
        },

        erroNaInclusaoDotacao() {
            this.$swal({
                title: 'Dotação Orçamentária',
                html: `Já existe dotação com a unidade/projeto/ação informados`,
                icon: 'error'
            })
        },

        atualizarRateio(rateio) {
            for (let index = 0; index < this.rateios.length; index++) {
                const rateioAtual = this.rateios[index]
                if (
                    rateioAtual.codCCusto == rateio.codCCusto
                ) {
                    this.rateios[index].nuValorRateio = rateio.nuValorRateio
                    break
                }
            }
        },

        excluirRateio(rateio) {
            for (let index = 0; index < this.rateios.length; index++) {
                const rateioAtual = this.rateios[index]
                if (
                    rateioAtual.codCCusto == rateio.codCCusto
                ) {
                    this.rateios.splice(index, 1)
                    break
                }
            }
        }
    },

    computed: {
        itensNaoSelecionados() {
            if (this.itensSelecionados.length > 0) {
                let seqRm = this.itensSelecionados[0].seqRm
                return this.itensDisponiveis.filter((itemDisponivel) => {
                    return this.itensSelecionados.every((itemSelecionado) => {
                        return (
                            itemSelecionado.idItemRequisicao !==
                                itemDisponivel.idItemRequisicao &&
                            itemDisponivel.seqRm == seqRm
                        )
                    })
                })
            }
            return this.itensDisponiveis
        },

        valorASerRateado() {
            return Number.parseFloat(
                this.itensSelecionados
                    .map((item) => {
                        return item.valorRateado
                    })
                    .reduce((a, b) => a + b, 0)
                    .toFixed(2)
            )
        },

        valorRateado() {
            return Number.parseFloat(
                this.rateios
                    .map((item) => {
                        return item.nuValorRateio
                    })
                    .reduce((a, b) => a + b, 0)
                    .toFixed(2)
            )
        },

        valorDisponivel() {
            return Number.parseFloat(
                (this.valorASerRateado - this.valorRateado).toFixed(2)
            )
        },

        percentualRateado() {
            return (this.valorRateado / this.valorASerRateado) * 100
        },

        desabilitaSalvar() {
            return (
                this.itensSelecionados.length == 0 ||
                this.valorDisponivel != 0 ||
                this.$v.$invalid ||
                this.rateios.length > 1
            )
        }
    },

    created() {},

    validations: {
        historicoComprometimento: {
            required
        },
        dataComprometimento: {
            required
        }
    },

    watch: {
        mostrarModal() {
            this.mostrarModalLocal = this.mostrarModal
        },
    }
}
</script>
